import { Injectable, inject } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';

import { FeatureFlagService } from '@digital-platform/util-feature-flags/services';
import { CanadianCustomerModalComponent } from '../canadian-customer-modal/canadian-customer-modal.component';

@Injectable({
  providedIn: 'root',
})
export class CanadianCustomerService {
  private cookieService = inject(CookieService);
  private modalService = inject(NgbModal);
  private featureFlagsService = inject(FeatureFlagService);

  openCanadianCustomerModal() {
    const isCanadianModalEnabled =
      !!this.featureFlagsService.getValue('canada-modal');

    const modalShown = this.cookieService.get('canadianCustomerModalShown');

    if (isCanadianModalEnabled && !modalShown) {
      const modalOptions: NgbModalOptions = {
        size: 'lg',
        centered: true,
      };
      const modalRef = this.modalService.open(
        CanadianCustomerModalComponent,
        modalOptions
      );

      modalRef.componentInstance.title = 'modalTitle';

      // Sets a session cookie to prevent the modal from showing again
      this.cookieService.set('canadianCustomerModalShown', 'true', {
        expires: 0,
      });
    }
  }
}
